import Backend from 'backend';
import {customElement, inject} from 'aurelia-framework';

@customElement('vmp-test-component')
@inject(Backend)
export class VmpTestComponent {
  available = false;
  orderType = 'NORMAL';
  orderNumber;
  message;
  orderTypes = [
    {
      id: 'NORMAL',
      name: '220 – Normalordre'
    },
    {
      id: 'ZNB',
      name: 'ZNB – Levert ikke bestilt vare'
    },
    {
      id: 'ZKA',
      name: 'ZKA – Kassasjonsordre'
    },
    {
      id: 'ZRE',
      name: 'ZRE – Returordre'
    }
  ];

  constructor(backend) {
    this.backend = backend;
  }

  attached() {
    // Show test tools only while the in-memory server is available
    return this.backend.VmpTestToolsQueryHandler_handle({})
      .then(result => this.available = result.available);
  }

  addOrder() {
    // Clear the previous result and capture the selected type before the request
    this.message = null;
    const orderType = this.orderType;

    // Add the order and fill in its number for a matching proof of delivery
    return this.backend.AddVmpTestDocumentCommandHandler_handle({
        documentType: 'ORDER',
        orderType: orderType,
        orderNumber: null
      })
      .then(document => {
        this.orderNumber = document.orderNumber;
        this.message = `Added ${document.path}. Use Check ftp to process it.`;
      });
  }

  addProofOfDelivery() {
    // Clear the previous result
    this.message = null;

    // Link the proof of delivery to the entered VMP order number
    return this.backend.AddVmpTestDocumentCommandHandler_handle({
        documentType: 'PROOF_OF_DELIVERY',
        orderType: null,
        orderNumber: this.orderNumber
      })
      .then(document => {
        this.message = `Added ${document.path} for order ${document.orderNumber}. Use Check ftp to process it.`;
      });
  }
}
